module.exports = __webpack_public_path__ + "static/media/12UNCTAD12.c8d9e915.jpg";